import api from "../../config/client.axios.api";

export const updateTypeTransactionApi = async (infoUpdate: any) => {
  const response = await api.put(`/type-transaction`, infoUpdate);
  return response.data;
};
